import { isClinicStoreType, isPetClinicStoreType } from './clinic-store-types.util';
import { isHostelStoreType } from './hostel-store-types.util';
import { isHotelStoreType } from './hotel-store-types.util';
import { isSchoolStoreType } from './school-store-types.util';
import { isCapitalStoreType } from './capital-store-types.util';
import { isFoodStoreType } from './food-store-types.util';
import { isRealtyStoreType } from './realty-store-types.util';
import { isInteriorStoreType } from './interior-store-types.util';
import { isTravelStoreType } from './travel-store-types.util';
import { isFashionStoreType } from './fashion-store-types.util';

/** Stores that use the profile business dashboard (consult or mobile shell) instead of My Business tiles. */
export function isProfileBusinessStoreType(storeType: string | null | undefined): boolean {
  // Pet-care / pet-clinic use `/mybusiness-pet` (handled separately).
  if (isPetClinicStoreType(storeType)) return false;
  if (isClinicStoreType(storeType)) return false;
  if (isHostelStoreType(storeType)) return false;
  if (isHotelStoreType(storeType)) return false;
  if (isSchoolStoreType(storeType)) return false;
  if (isCapitalStoreType(storeType)) return false;
  if (isFoodStoreType(storeType)) return false;
  if (isFashionStoreType(storeType)) return false;
  if (isRealtyStoreType(storeType)) return false;
  if (isInteriorStoreType(storeType)) return false;
  if (isTravelStoreType(storeType)) return false;
  return true;
}
